import type { SourceDiscoverResult, SourceDiscoverSection, SourceManifest } from "../api";

export function getVisibleSourceCapabilities(source: SourceManifest): string[] {
  return source.capabilities.filter(capability => capability === "search" || capability === "discover");
}

export function isHomeDiscover(discover: SourceDiscoverResult): boolean {
  if (!discover.currentUrl) return true;

  const url = new URL(discover.currentUrl);
  return url.pathname === "/";
}

export function sectionSupportsPagination(section?: SourceDiscoverSection): boolean {
  if (!section) return false;
  return section.title === "最近" || section.title === "入库";
}
